<template>

    <div class="dropdown dropdown-singlechoice" :class="{'disabled': this.disabled}" :id="'dropdown-singlechoice-'+this.name">
        <button class="btn btn-outline-light dropdown-toggle" aria-expanded="true" data-toggle="dropdown" type="button"
            :class="{'active': this.mutChecked[0] != this.defaultValues[0], 'icon-button': this.type === 'icon-button'}">
                <i class="dropdown-icon" v-if="this.icon" :class="this.icon"></i>
                <span v-if="this.label">{{ this.label }}</span>
                <small class="bdg-count btn-primary" v-if="this.mutChecked[0] != this.defaultValues[0]"><i class="fal fa-asterisk"></i></small>
        </button>
        <div class="dropdown-menu" :class="{'dropdown-menu-right': this.alignRight}">
            <div class="bg-light dropdown-item px-3 pt-3 pb-2 noselect">
                <h5>{{ this.title }}</h5>
            </div>

            <div class="dropdown-menu-content" :class="{'has-submit': hasSubmit() || hasReset()}">
                <div class="dropdown-item p-0" v-for="(item) in options">
                    <div class="form-check">
                        <input class="form-check-input" type="radio" autocomplete="off"
                            :name="getInputName(item)"
                            :value="item.value"
                            :id="getInputId(item)"
                            :checked="itemChecked(item)"
                            @change="itemChange(item)">

                        <label class="form-check-label" :for="getInputId(item)">{{ item.label }}</label>
                    </div>
                </div>

                <div class="dropdown-btns">
                    <button class="btn btn-danger" v-if="hasReset()" @click="reset()" :disabled="disabled">
                        <i class="far fa-undo fa-fw mr-2"></i>
                        {{ trans('reset') }}
                    </button>
                    <button class="btn btn-primary" v-if="hasSubmit()" @click="submit()" :disabled="disabled">
                        <i class="far fa-check fa-fw mr-2"></i>
                        {{ trans('save') }}
                    </button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import {cloneDeep} from "lodash";
    import TranslationsUtils from "../../app-components/TranslationsUtils";

    export default {
        mixins: [TranslationsUtils],
        props: {
            'type': { // form-control | icon-button
                type: String,
                default: 'form-control'
            },
            'name': {
                type: String
            },
            'icon': {
                type: String
            },
            'label': {
                type: String
            },
            'title': {
                type: String
            },
            'options': {
                type: Array
            },
            'checked': {
                type: Array,
                default: function() {
                    return [];
                }
            },
            'defaultValues': {
                type: Array,
                default: function() {
                    return [];
                }
            },
            'disabled': {
                type: Boolean,
                default: false
            },
            'alignRight': {
                type: Boolean,
                default: false
            },
            'onchange': { type: Function },
            'onsubmit': { type: Function },
            'onreset': { type: Function },
            'resetTrigger': { type: Number }
        },

        data() {
            return {
                mutChecked: cloneDeep(this.checked),
            };
        },

        methods: {
            getInputId(item) {
                return this.name + '-' + item.value;
            },
            getInputName(item) {
                return this.name;
            },

            itemChecked(item) {
                return this.mutChecked[0] == item.value;
            },

            itemChange(item) {
                this.mutChecked = [item.value];
                this.triggerChange();
            },

            hasSubmit() {
                return typeof this.onsubmit !== 'undefined';
            },

            submit() {
                if(this.hasSubmit()) {
                    this.onsubmit(this.mutChecked);
                }
                this.closeDropdown();
            },

            hasReset() {
                return typeof this.onreset !== 'undefined';
            },

            reset() {
                if(this.hasReset()) {
                    this.onsubmit([]); // toto je takto naschval!
                }
                this.closeDropdown();
            },

            closeDropdown() {
                this.$el.classList.remove('open');
            },

            triggerChange() {
                if (this.onchange) {
                    this.onchange(this.name, this.mutChecked);
                }
            },
        },

        watch: {
            resetTrigger() {
                this.mutChecked = cloneDeep(this.checked);
            }
        }

    }
</script>


<style lang="scss">
    .dropdown-singlechoice {
        width: 100%;

        &.disabled {
            opacity: 0.7;
            pointer-events: none;
        }

        .dropdown-toggle {
            color: #3e515b;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 100%;
            border: 1px solid #b9c8de;
            border-radius: 0;
            background: white;

            &.active {
                padding-right: 40px;
                color: #343A40;
            }

            &.icon-button {
                border: 0;
                background: none;
                width: auto;
            }

            &::after {
                margin-left: 0.5em;
            }

            .bdg-count {
                position: absolute;
                right: 5px;
                top: 5px;
                padding: 5px 8px;
                border-radius: 3px;
                color: #fff; // .card small by ho inak zosedivelo

                .fal {
                    font-size: 80%;
                }
            }
        }

        .dropdown-menu {
            h5 {
                font-weight: bold;
                padding: 0px;
                font-size: 0.9rem;
                user-select: none;
            }
            .check-uncheck-link {
                padding: 0px;
                margin: 0px;
                font-size: 0.7rem;
                cursor: pointer;
                user-select: none;
                text-decoration: underline;
            }

            .dropdown-menu-content {
                max-height: 40vh;
                overflow-y: auto;

                &.has-submit {
                    padding-bottom: 36px;
                }
            }

            .form-check {
                margin: 0px;
                display: flex;
                align-items: center;

                .form-check-label {
                     display: block;
                     margin: 0px;
                     padding: 10px 10px 10px 15px;
                     user-select: none;
                    cursor: pointer;

                     &:before {
                        top: 10px;
                        left: 15px;
                     }
                     &:after {
                        top: 15px;
                        left: 20px;
                     }
                }

                .form-check-input {
                    position: static !important;
                    margin-top: 0 !important;
                    margin-left: 15px !important;
                    cursor: pointer;
                }
            }

            .dropdown-btns {
                display: flex;
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                background-color: white;

                .btn {
                    border-radius: 0;
                    display: block;
                    cursor: pointer;
                    color: white;
                    min-width: 50%;
                    flex-grow: 1;

                    .far { color: white !important; }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/admin/js/components/basic/DropdownSinglechoice.vue